import HomePage from './components/HomePage';

function App() {
   return (
      <div className="relative min-h-screen bg-zinc-50 text-zinc-900 dark:bg-zinc-950 dark:text-zinc-50 transition-colors duration-300">
         {/* Decorative background layers */}
         <div className="pointer-events-none fixed inset-0 -z-10 bg-grid opacity-60" />
         <div className="pointer-events-none fixed inset-x-0 top-0 -z-10 h-[520px] bg-radial-glow" />
         <HomePage />
      </div>
   );
}

export default App;
